import { Box, Text } from '@jfs/ui-new'
import { observer } from 'mobx-react'
import * as React from 'react'
import { FC, ReactElement } from 'react'
import { TableComponent } from '../../../comps/TableComponent'
import { useWindowDimensions } from '../../../util/util'
import { styles } from '../styles'

interface PersonalProps {
  hide?: boolean
  data: any
}

const personalProfData = (email: string, mobile: string) => {
  return [
    { key: '1', title: 'Phone', value: mobile ? '+91' + mobile?.replace('91', '') : 'NA' },
    { key: '2', title: 'Email', value: email ?? 'NA' },
    // { key: '3', title: 'Last logged in data & time', value: lldate },
  ]
}

const Personal: FC<PersonalProps> = ({ hide, data }: PersonalProps) => {
  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles(viewPortWidth)

  if (hide) {
    return null
  }

  const renderListItem = ({ item }: any): ReactElement => {
    return (
      <Box {...themedStyle.listItemContainer}>
        <Text {...themedStyle.listItemKeyStyle} testID="key">
          {item?.title}
        </Text>
        <Text {...themedStyle.listItemValueStyle} testID={`personalTabView-${item?.title?.replaceAll(' ', '')}`}>
          {item?.value}
        </Text>
      </Box>
    )
  }

  const getSeperator = (): React.ReactElement => {
    return <Box {...themedStyle.separatorStyle} />
  }

  return (
    <Box testID={'personalTabView'} {...themedStyle.personalDataContainer}>
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={personalProfData(data?.contact?.email, data?.contact?.mobile)}
        hide={false}
        isCustom={true}
        RenderCustomElement={renderListItem}
        ItemSeparatorComponent={getSeperator}
      />
    </Box>
  )
}
export default observer(Personal)
